import { PaginationQuery } from "@/types/common";
import { TMSAddressVo } from "../address";
import { TMSPalletVo, TMSScanPalletProductVo } from "../pallet";

export enum TMSOrderType {
  Direct = "Direct",
  Unloading = "Unloading",
  Local = "Local",
  Scan = "Scan",
  Other = "Other",
}

export enum TMSOrderStatus {
  Deleted = "Deleted",
  Created = "Created",
  Processing = "Processing",
  Completed = "Completed",
}

export interface DirectDelivery {
  warehouseName: string;
  phone: string;
  email: string;
  attn: string;
  factoryNo: string;
  accessories: string;
  address: string;
  comment: string;
}

export enum TMSOrderVCType {
  Amazon = "Amazon",
  BestBuy = "BestBuy",
  Target = "Target",
  Other = "Other",
  NEXCOM = "NEXCOM",
  AAFES = "AAFES",
}

export interface TMSOrderVCInfo {
  type: TMSOrderVCType;
  carrierName: string;
  bolNo: string;
  proNo: string;
  arnNo: string;
  poNo: string;
}

export interface ProxyOrderReport {
  shipmentNo: string;
  reportedAt: string;
}

export interface TMSOrderVo {
  id: string;
  no: string;
  type: TMSOrderType;
  status: TMSOrderStatus;
  riiOrderNo: string;
  containerId: string;
  containerNo: string;
  customer: string;
  createdTime: Date;
  updatedTime: Date;
  deliveryDate: Date;
  directDeliveryInfo: DirectDelivery;
  vcInfo: TMSOrderVCInfo;
  scanConfig: TMSScanOrderConfig;
  reports: ProxyOrderReport[];
}

export interface TMSScanOrderProductVo {
  id: number;
  groupId: string;
  customerOrderNo: string;
  productNo: string;
  productName: string;
  productBarcode: string;
  perPackageQty: number;
  quantity: number;
  cartons: number;
  active: boolean;
  extra: {
    scanSerialNo?: boolean;
  }
}

export interface TMSScanOrderGroupVo {
  id: string;
  orderId: string;
  addressId: string;
  customerRefNo: string;
  palletCount: number;
  address: TMSAddressVo;
}

export interface TMSScanOrderVo extends TMSOrderVo {
  products: TMSScanOrderProductVo[];
  groups: TMSScanOrderGroupVo[];
}

export interface TMSScanOrderCartonVo extends TMSScanOrderProductVo {
  scanned: number;
}

export type TMSOrderSearchParams = Partial<PaginationQuery> & {
  ids?: string[];
  nos?: string[];
  fuzzyRiiOrderNo?: string;
  fuzzyContainerNo?: string;
  fuzzyRiiContainerNo?: string;
  riiOrderNos?: string[];
  typeList?: TMSOrderType[];
  statusList?: TMSOrderStatus[];
  fuzzyCustomer?: string;
  createdTimeRange?: string[];
  scanOrderProductCustomerOrderNo?: string;
};

export interface TMSProductCartionDo {
  productNo: string;
  quantity: number;
  qtyPerCarton: number;
}

export enum TMSShippingLabelMode {
  Disabled = "Disabled",
  Pallet = "Pallet",
  Carton = "Carton",
}

export interface TMSScanOrderConfig {
  hasCartonLabel: boolean;
  isSSCCOrder: boolean;
  shippingLabelMode: TMSShippingLabelMode;
  shippingLabelCount?: number;
  applyPalletLabel: boolean;
  requirePalletDimension: boolean;
  shippingLabelPageMap?: Record<number, string>;
  uploadedPalletShippingLabels?: boolean
}

export interface TMSScanOrderCreateDo {
  customerId: number;
  addressId: string;
  integrationOrderId: string;
  cubeOrderNo: string;
  productCartons: TMSProductCartionDo[];
  useAllProducts: boolean;
  scanConfig: TMSScanOrderConfig;
  vcInfo?: TMSOrderVCInfo;
}

export interface TMSScanPalletCreateDo {
  groupId: number;
  orderId: string;
}

export interface TMSScanOrderPalletVo extends TMSPalletVo {
  scanConfig: TMSScanOrderConfig;
  products: TMSScanOrderProductVo[];
  group: TMSScanOrderGroupVo;
  scannedProducts: TMSScanPalletProductVo[];
}

export interface TMSScanShippingLabelDo {
  orderIdOrNo: string;
  palletId: string;
  palletProductId?: string;
}

export interface TMSScanOrderShippingLabelUsage {
  shippingLabelMode: TMSShippingLabelMode;
  palletCount: number;
  scannedCartonCount: number;
  totalLabelsCount: number;
}
